import { asConditionId, type ConditionId } from "@repo/domain";
import { z } from "zod";
import { newEntityIdSchema } from "./entity-id.schemas";
import { patientRefSchema } from "./patient.schemas";
import { practitionerRefSchema } from "./practitioner.schemas";
import { codeableConceptSchema } from "./schedule.schemas";
import { visitIdSchema } from "./visit.schemas";

const clinicalStatusSchema = z.enum(["active", "recurrence", "relapse", "inactive", "remission", "resolved"]);
const verificationStatusSchema = z.enum([
  "unconfirmed",
  "provisional",
  "differential",
  "confirmed",
  "refuted",
  "entered-in-error",
]);
const categorySchema = z.enum(["encounter-diagnosis", "problem-list-item"]);
export const conditionIdSchema: z.ZodType<ConditionId, z.ZodTypeDef, string> = z
  .string()
  .min(1)
  .transform(asConditionId);

export const createConditionInputSchema = z.object({
  id: newEntityIdSchema,
  patient: patientRefSchema,
  visitId: visitIdSchema.optional(),
  category: categorySchema.default("encounter-diagnosis"),
  clinicalStatus: clinicalStatusSchema.default("active"),
  verificationStatus: verificationStatusSchema.default("provisional"),
  code: codeableConceptSchema,
  recorder: practitionerRefSchema.optional(),
  recordedDate: z.string().optional(),
  severity: codeableConceptSchema.optional(),
  note: z.string().optional(),
});
export type CreateConditionInput = z.infer<typeof createConditionInputSchema>;

export const updateConditionInputSchema = z.object({
  conditionId: conditionIdSchema,
  clinicalStatus: clinicalStatusSchema.optional(),
  verificationStatus: verificationStatusSchema.optional(),
  severity: codeableConceptSchema.optional(),
  onsetDateTime: z.string().optional(),
  note: z.string().optional(),
});
export type UpdateConditionInput = z.infer<typeof updateConditionInputSchema>;
